@if (selectedTabDv === 0 && (werknemerEntity$ | async)) {

  <div class="row pt-3 pb-1">
    <div class="col col-1">
      <b>VASTE VERGOEDINGEN EN INHOUDINGEN</b>
    </div>
    <div class="col-2"></div>
    <div class="col-3"></div>
  </div>

  <snelstart-ui-button (click)="addRijVergoedingen()" class="snelstart-ui-button mb-1" icon="plus" id="cancel"
                       type="link">Nieuwe vergoeding/inhouding toevoegen
  </snelstart-ui-button>

  <form [formGroup]="lijstFg">
    <div class="row">
      <div formArrayName="vergoedingen">
        @for (item of vergoedingen.controls; track item; let i = $index) {
          <div [formGroupName]="i" class="row mb-0.5">
            <div class="col-auto">
              <div [formGroup]="item.controls.periode">
                <snelstart-ui-date-form-control [disabledControl]="!!vergoedingen.at(i).getRawValue().periode.einddatum"
                                                (change)="onPeriodeChange('vergoeding', i)"
                                                [label]="i === 0 ? 'Ingangsdatum' : ''"
                                                [formControl]="item.controls.periode.controls.begindatum"
                                                [required]="true"
                                                class="custom-input-150"
                                                id="begindatum"
                >
                </snelstart-ui-date-form-control>
              </div>
            </div>
            <div class="col-auto">
              <div [formGroup]="item.controls.periode">
                <snelstart-ui-date-form-control [disabledControl]="isVergoedingEinddatumDisabled(i)"
                                                (change)="onPeriodeChange('vergoeding', i)"
                                                [formControl]="item.controls.periode.controls.einddatum"
                                                [label]="i === 0 ? 'Einddatum' : ''"
                                                class="custom-input-150"
                                                id="einddatum"
                >
                </snelstart-ui-date-form-control>
              </div>
            </div>
            <div class="col-auto">
              <snelstart-ui-select-form-control [label]="i === 0 ? 'Salariscomponent' : ''"
                                                (change)="requestPersist()"
                                                [formControl]="item.controls.component"
                                                [options]="optionsComponenten"
                                                class="me-1 custom-input-250"
                                                id="component"
              >
              </snelstart-ui-select-form-control>
            </div>
            <div class="col-auto">
              <snelstart-ui-number-form-control [formControl]="item.controls.bedrag"
                                                (change)="requestPersist()"
                                                [label]="i === 0 ? 'Bedrag' : ''"
                                                [prefix]="'€'"
                                                [showAllDecimals]="true"
                                                align="right"
                                                class="custom-input-150"
              >
              </snelstart-ui-number-form-control>
            </div>
            <div class="col-auto">
              @if (!vergoedingen.at(i).getRawValue().periode.einddatum) {
                <snelstart-ui-button (click)="verwijderRij('vergoeding', i)"
                                     [class]="i === 0 ? 'firstrowbutton' : ''"
                                     icon="trash"
                                     id="delete"
                                     size="medium"
                                     type="secondary">
                </snelstart-ui-button>
              }
            </div>
            @if (item.controls.periode.hasError('begindatumVoorDatumInDienst') || item.controls.periode.hasError('einddatumVoorBegindatum')) {
              <div class="col-12 mb-2" style="margin-top: -8px;">
                @if (item.controls.periode.hasError('begindatumVoorDatumInDienst')) {
                  <div class="text-danger small">Ingangsdatum mag niet vóór datum indienst liggen.</div>
                }
                @if (item.controls.periode.hasError('einddatumVoorBegindatum')) {
                  <div class="text-danger small">Einddatum mag niet vóór ingangsdatum liggen.</div>
                }
              </div>
            }
          </div>
        }
      </div>
    </div>
  </form>


  <div class="row pt-3 pb-1">
    <div class="col col-1">
      <b>RESERVERINGEN</b>
    </div>
    <div class="col-2"></div>
    <div class="col-3"></div>
  </div>

  <snelstart-ui-button (click)="addRijReservering()" class="snelstart-ui-button mb-1" icon="plus" id="cancel"
                       type="link">Nieuwe reservering toevoegen
  </snelstart-ui-button>

  <form [formGroup]="lijstFg">
    <div class="row">
      <div formArrayName="reserveringen">
        @for (item of reserveringen.controls; track item; let i = $index) {
          <div [formGroupName]="i" class="row mb-0.5">
            <!-- Ingangsdatum -->
            <div class="col-auto">
              <div [formGroup]="item.controls.periode">
                <snelstart-ui-date-form-control
                  (change)="onPeriodeChange('reservering', i)"
                  [disabledControl]="!!reserveringen.at(i).getRawValue().periode.einddatum"
                  [formControl]="item.controls.periode.controls.begindatum"
                  [label]="i === 0 ? 'Ingangsdatum' : ''"
                  class="custom-input-150"
                  id="res-begindatum"
                >
                </snelstart-ui-date-form-control>
              </div>
            </div>

            <!-- Einddatum -->
            <div class="col-auto">
              <div [formGroup]="item.controls.periode">
                <snelstart-ui-date-form-control
                  (change)="onPeriodeChange('reservering', i)"
                  [disabledControl]="isReserveringEinddatumDisabled(i)"
                  [formControl]="item.controls.periode.controls.einddatum"
                  [label]="i === 0 ? 'Einddatum' : ''"
                  class="custom-input-150"
                  id="res-einddatum"
                >
                </snelstart-ui-date-form-control>
              </div>
            </div>

            <!-- Reserveringcomponent -->
            <div class="col-auto">
              <snelstart-ui-select-form-control
                (change)="requestPersist()"
                [disabledControl]="!!reserveringen.at(i).getRawValue().periode.einddatum"
                [formControl]="item.controls.component"
                [label]="i === 0 ? 'Reserveringcomponent' : ''"
                [options]="optionsComponentenReservering"
                class="me-1 custom-input-250"
                id="res-component"
              >
              </snelstart-ui-select-form-control>
            </div>

            <!-- Percentage -->
            <div class="col-auto">
              <snelstart-ui-number-form-control
                (change)="requestPersist()"
                [disabledControl]="!!reserveringen.at(i).getRawValue().periode.einddatum"
                [formControl]="item.controls.percentage"
                [label]="i === 0 ? 'Percentage' : ''"
                [prefix]="'%'"
                [showAllDecimals]="true"
                align="right"
                class="custom-input-150"
                id="res-percentage"
              >
              </snelstart-ui-number-form-control>
            </div>

            <!-- + Meer gegevens -->
            <div class="col-auto">
              <snelstart-ui-button
                (click)="showDialog(i)"
                [class]="i === 0 ? 'firstrowbutton' : ''"
                [disabled]="isReserveringMeerGegevensDisabled(i)"
                icon="plus"
                id="res-meer-gegevens"
                style="margin-top: -2px;"
                type="secondary"
              >
                Meer gegevens
              </snelstart-ui-button>
            </div>

            <div class="col-auto align-self-start">
              @if (!reserveringen.at(i).getRawValue().periode.einddatum) {
                <snelstart-ui-button
                  (click)="verwijderRij('reservering', i)"
                  [class]="i === 0 ? 'firstrowbutton' : ''"
                  icon="trash"
                  id="res-delete"
                  size="medium"
                  type="secondary">
                </snelstart-ui-button>
              }
            </div>
            @if (item.controls.periode.hasError('begindatumVoorDatumInDienst') || item.controls.periode.hasError('einddatumVoorBegindatum')) {
              <div class="col-12 mt-1">
                @if (item.controls.periode.hasError('begindatumVoorDatumInDienst')) {
                  <div class="text-danger small">Ingangsdatum mag niet vóór datum indienst liggen.</div>
                }
                @if (item.controls.periode.hasError('einddatumVoorBegindatum')) {
                  <div class="text-danger small">Einddatum mag niet vóór ingangsdatum liggen.</div>
                }
              </div>
            }
          </div>
        }
      </div>
    </div>
  </form>
}

<snelstart-ui-dialog-definition [(visible)]="dialogVisible" id="Specificatie reservering"
                                size="lg"
                                title="Specificatie reservering">
  <snelstart-ui-dialog-body class="full-height">
    <form [formGroup]="lijstFg">
      <div formArrayName="reserveringen">
        @for (item of reserveringen.controls; track item; let i = $index) {
          <div [formGroupName]="i">
            @if (i === index) {
            <!--             TODO: volgende versie, controleren of dan wel dit component werkt.-->
            <!--            <snelstart-ui-multi-select-form-control (change)="saveForm()"-->
            <!--                                                    [options]="optionsGrondslagComponenten"-->
            <!--                                                    class="me-1 custom-input-250"-->
            <!--                                                    formControlName="grondslagComponenten"-->
            <!--                                                    id="grondslagComponenten"-->
            <!--                                                    label="Grondslag reservering"-->
            <!--            >-->
            <!--            </snelstart-ui-multi-select-form-control>-->
            <div class="mb-3">
              <label class="form-label" for="grondslagComponenten">
                Grondslag reservering (meerdere selecties mogelijk)
              </label>

              <select
                class="form-select custom-input-250"
                [formControl]="item.controls.grondslagComponenten"
                id="grondslagComponenten"
                multiple>
                @for (opt of optionsGrondslagComponenten; track opt.value) {
                  <option [ngValue]="opt.value">{{ opt.text }}</option>
                }
              </select>
            </div>

            <snelstart-ui-select-form-control (change)="requestPersist()"
                                              [formControl]="item.controls.periodeVrijval"
                                              [options]="optionsVrijval"
                                              class="me-1 custom-input-250"
                                              id="periodeVrijval"
                                              label="Vrijval periode"
            >
            </snelstart-ui-select-form-control>
            <div>
              <snelstart-ui-number-form-control (change)="requestPersist()"
                                                [formControl]="item.controls.cumulatiefSaldoBeginPeriode"
                                                [prefix]="'€'"
                                                [showAllDecimals]="true"
                                                align="right"
                                                class="me-1 custom-input-250"
                                                id="cumulatiefSaldoBeginPeriode"
                                                label="Reservering bij aanvang jaar"
              >
              </snelstart-ui-number-form-control>
            </div>
            }
          </div>
        }
      </div>
    </form>
  </snelstart-ui-dialog-body>
  <snelstart-ui-dialog-buttons class="d-flex">
    <snelstart-ui-button btn-x class="me-1" id="cancel1" type="secondary">Annuleren</snelstart-ui-button>
    <snelstart-ui-button (click)="requestPersist()" icon="check" id="save" type="primary">Opslaan</snelstart-ui-button>
  </snelstart-ui-dialog-buttons>
</snelstart-ui-dialog-definition>

